import { useTranslation } from "react-i18next";
import { Button, Icon, Modal, Text, VStack } from "@repo/ui";
import { spacingV2, useTheme } from "@repo/tokens";
import { useIsMobile } from "@repo/utils";

import { useRegisterToUnlockOverlayStyles } from "./styles";

export type RegisterToUnlockOverlayProps = {
  isOpen: boolean;
  onClose: () => void;
};

export function RegisterToUnlockOverlay({
  isOpen,
  onClose,
}: RegisterToUnlockOverlayProps) {
  const { t } = useTranslation("tests");
  const { theme } = useTheme();
  const isMobile = useIsMobile();
  const styles = useRegisterToUnlockOverlayStyles(isMobile);
  const copy = {
    title: t("register_to_unlock_overlay.title"),
    description: t("register_to_unlock_overlay.description"),
    action: t("okay"),
  };

  return (
    <Modal
      isModalOpen={isOpen}
      onClose={onClose}
      showHeader={false}
      showFooter={false}
      width={isMobile ? "100%" : "min(400px, 92vw)"}
      height="auto"
      justifyContent={isMobile ? "flex-end" : "center"}
      alignItems={isMobile ? "flex-end" : "center"}
      styles={styles.modal}
      body={
        <VStack align="center" style={styles.content}>
          <Icon
            name="doubtExhaustLockIcon"
            width={spacingV2[48]}
            height={spacingV2[48]}
            color={theme.colors.primary[30]}
          />

          <Text style={styles.title}>{copy.title}</Text>
          <Text style={styles.description}>{copy.description}</Text>

          <Button
            variant="primary"
            shape="circle"
            size="lg"
            width="100%"
            backgroundColor={theme.colors.primary[30]}
            textColor={theme.colors.neutral[100]}
            onPress={onClose}
          >
            {copy.action}
          </Button>
        </VStack>
      }
    />
  );
}
